// httpClient.js
import { fetchUtils } from "react-admin";

export const apiEndpoint = process.env.REACT_APP_TURUK_CLINIC_ADMIN_REST_API;

// Requests to clinic-admin-api with the clinic manager token
export const httpClient = (url, options = {}) => {
    if (!options.headers) {
        options.headers = new Headers({ Accept: 'application/json' });
    }
    // Добавляем токен авторизации, если он есть
    const token = localStorage.getItem('auth_token');
    if (token) {
        options.headers.set('Authorization', `Bearer ${token}`);
    }
    // Убедимся, что Content-Type установлен для запросов с телом
    if (options.method && ['POST', 'PUT', 'PATCH'].includes(options.method)) {
        options.headers.set('Content-Type', 'application/json');
    }

    return fetchUtils.fetchJson(url, options);
};
